import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import ChangeStrategy from '../pages/projects/change-strategy/index';
import ChangeStrategySettings from '../pages/projects/change-strategy/settings';
import ChangeStrategyNewStepGeneral from '../pages/projects/change-strategy/new/step-general';
import ChangeStrategyNewStepDetails from '../pages/projects/change-strategy/new/step-details';
import ChangeStrategyNewStepGovernance from '../pages/projects/change-strategy/new/step-governance';
import ChangeStrategyNewStepMilestones from '../pages/projects/change-strategy/new/step-milestones';
import ChangeStrategyNewStepLinkedFiles from '../pages/projects/change-strategy/new/step-linked-files';
import ChangeStrategyEditStepGeneral from '../pages/projects/change-strategy/edit/step-general';
import ChangeStrategyEditStepDetails from '../pages/projects/change-strategy/edit/step-details';
import ChangeStrategyEditStepGovernance from '../pages/projects/change-strategy/edit/step-governance';
import ChangeStrategyEditStepMilestones from '../pages/projects/change-strategy/edit/step-milestones';
import ChangeStrategyEditStepLinkedFiles from '../pages/projects/change-strategy/edit/step-linked-files';

export const changeStrategyRoutes = () => (
  <>
    <Route path={ROUTES.CHANGE_STRATEGY_INDEX} element={<ChangeStrategy />} />
    <Route
      path={ROUTES.CHANGE_STRATEGY_SETTINGS}
      element={<ChangeStrategySettings />}
    />

    {/* Change Strategy New Steps */}
    <Route
      path={ROUTES.CHANGE_STRATEGY_NEW_STEP_GENERAL}
      element={<ChangeStrategyNewStepGeneral />}
    />
    <Route
      path={ROUTES.CHANGE_STRATEGY_NEW_STEP_DETAILS}
      element={<ChangeStrategyNewStepDetails />}
    />
    <Route
      path={ROUTES.CHANGE_STRATEGY_NEW_STEP_GOVERNANCE}
      element={<ChangeStrategyNewStepGovernance />}
    />
    <Route
      path={ROUTES.CHANGE_STRATEGY_NEW_STEP_MILESTONES}
      element={<ChangeStrategyNewStepMilestones />}
    />
    <Route
      path={ROUTES.CHANGE_STRATEGY_NEW_STEP_LINKED_FILES}
      element={<ChangeStrategyNewStepLinkedFiles />}
    />

    {/* Change Strategy Edit Steps */}
    <Route
      path={ROUTES.CHANGE_STRATEGY_EDIT_STEP_GENERAL}
      element={<ChangeStrategyEditStepGeneral />}
    />
    <Route
      path={ROUTES.CHANGE_STRATEGY_EDIT_STEP_DETAILS}
      element={<ChangeStrategyEditStepDetails />}
    />
    <Route
      path={ROUTES.CHANGE_STRATEGY_EDIT_STEP_GOVERNANCE}
      element={<ChangeStrategyEditStepGovernance />}
    />
    <Route
      path={ROUTES.CHANGE_STRATEGY_EDIT_STEP_MILESTONES}
      element={<ChangeStrategyEditStepMilestones />}
    />
    <Route
      path={ROUTES.CHANGE_STRATEGY_EDIT_STEP_LINKED_FILES}
      element={<ChangeStrategyEditStepLinkedFiles />}
    />
  </>
);
